// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-lightBlueSubTitle":"jobSearchDetail-lightBlueSubTitle"};